import MuiTextField, { type TextFieldProps } from '@mui/material/TextField';
import React from 'react';

const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    return <MuiTextField ref={ref} size="small" margin="dense" {...props} />;
  },
);
TextField.displayName = 'TextField';
export default TextField;
